export function registerAppServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  const serviceWorkerPath = process.env.REACT_APP_SERVICE_WORKER_PATH;
  if (!serviceWorkerPath) return;

  window.addEventListener('load', () => {
    let reloading = false;
    let controlled = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (controlled && !reloading) {
        reloading = true;
        window.location.reload();
      }
      controlled = true;
    });
    navigator.serviceWorker.register(serviceWorkerPath)
      .then(registration => registration.update())
      .catch(error => {
        console.error('Service worker registration failed:', error);
      });
  });
}
